import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = { class: "pb-10 pl-10 pb-lg-15" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder d-flex align-items-center text-dark mb-10" }, " Risk Details ", -1)
const _hoisted_6 = { class: "fv-row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Does the research involve ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex text-gray-400 align-items-center form-label mb-8" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Check all that apply ")
], -1)
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Any surgical procedure")
], -1)
const _hoisted_12 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Administration of approved/unapproved drugs, chemical, or biological agents")
], -1)
const _hoisted_14 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Only administration of legend drugs ")
], -1)
const _hoisted_16 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Administration of approved/unapproved devices")
], -1)
const _hoisted_18 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Radioisotopes or other sources of ionizing radiation Placebos")
], -1)
const _hoisted_20 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Controlled Substances")
], -1)
const _hoisted_22 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Recombinant DNA (including use of vectors) ")
], -1)
const _hoisted_24 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Human Gene Transfer")
], -1)
const _hoisted_26 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Biological Toxins (including truncated or mutated toxins)")
], -1)
const _hoisted_28 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Infectious Agents (bacteria, viruses, protozoans, fungi)")
], -1)
const _hoisted_30 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Embryonic stem cells")
], -1)
const _hoisted_32 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Administration of physical stimuli Major changes in diet, exercise, or sleep Blood Draw")
], -1)
const _hoisted_34 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Use of private records (medical or educational records)")
], -1)
const _hoisted_36 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Possible invasion of privacy of subject or family")
], -1)
const _hoisted_38 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Manipulation of psychological or social variables such as sensory deprivation, social isolation, psychological stresses")
], -1)
const _hoisted_40 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Any probing for personal or sensitive information in surveys or interviews")
], -1)
const _hoisted_42 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Presentation of materials which subjects might consider sensitive, offensive, threatening or degrading")
], -1)
const _hoisted_44 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Use of a deceptive technique ")
], -1)
const _hoisted_46 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "Other risks, specify")
], -1)
const _hoisted_48 = { class: "form-check form-check-custom form-check-solid align-items-start mb-4" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-7 mb-0" }, "None of the above")
], -1)
const _hoisted_50 = { class: "mb-6" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Other risks, specify ")
], -1)
const _hoisted_52 = { class: "fv-row mb-10" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, " Describe the nature and degree of the risk or harm checked above. ")
], -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex text-gray-400 align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, " The described risks/harms must be disclosed in the consent form ")
], -1)
const _hoisted_55 = { class: "fv-row mb-10" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Describe the precautions that will be taken to minimize risk to the subjects: ")
], -1)
const _hoisted_57 = { class: "fv-row mb-10" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Justify the risk in terms of the potential scientific yield and/or in relation to the anticipated benefits to the subjects ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p1",
                value: "1",
                modelValue: _ctx.step1.p1,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step1.p1) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_11
            ]),
            _createElementVNode("label", _hoisted_12, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p2",
                value: "1",
                modelValue: _ctx.step1.p2,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step1.p2) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_13
            ]),
            _createElementVNode("label", _hoisted_14, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p3",
                value: "1",
                modelValue: _ctx.step1.p3,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step1.p3) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_15
            ]),
            _createElementVNode("label", _hoisted_16, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p4",
                value: "1",
                modelValue: _ctx.step1.p4,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step1.p4) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_17
            ]),
            _createElementVNode("label", _hoisted_18, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p5",
                value: "1",
                modelValue: _ctx.step1.p5,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step1.p5) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_19
            ]),
            _createElementVNode("label", _hoisted_20, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p6",
                value: "1",
                modelValue: _ctx.step1.p6,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step1.p6) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_21
            ]),
            _createElementVNode("label", _hoisted_22, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p7",
                value: "1",
                modelValue: _ctx.step1.p7,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step1.p7) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_23
            ]),
            _createElementVNode("label", _hoisted_24, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p8",
                value: "1",
                modelValue: _ctx.step1.p8,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step1.p8) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_25
            ]),
            _createElementVNode("label", _hoisted_26, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p9",
                value: "1",
                modelValue: _ctx.step1.p9,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.step1.p9) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_27
            ]),
            _createElementVNode("label", _hoisted_28, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p10",
                value: "1",
                modelValue: _ctx.step1.p10,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.step1.p10) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_29
            ]),
            _createElementVNode("label", _hoisted_30, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p11",
                value: "1",
                modelValue: _ctx.step1.p11,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.step1.p11) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_31
            ]),
            _createElementVNode("label", _hoisted_32, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p12",
                value: "1",
                modelValue: _ctx.step1.p12,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.step1.p12) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_33
            ]),
            _createElementVNode("label", _hoisted_34, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p13",
                value: "1",
                modelValue: _ctx.step1.p13,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.step1.p13) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_35
            ]),
            _createElementVNode("label", _hoisted_36, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p14",
                value: "1",
                modelValue: _ctx.step1.p14,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.step1.p14) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_37
            ]),
            _createElementVNode("label", _hoisted_38, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p15",
                value: "1",
                modelValue: _ctx.step1.p15,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.step1.p15) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_39
            ]),
            _createElementVNode("label", _hoisted_40, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p16",
                value: "1",
                modelValue: _ctx.step1.p16,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.step1.p16) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_41
            ]),
            _createElementVNode("label", _hoisted_42, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p17",
                value: "1",
                modelValue: _ctx.step1.p17,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.step1.p17) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_43
            ]),
            _createElementVNode("label", _hoisted_44, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p18",
                value: "1",
                modelValue: _ctx.step1.p18,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.step1.p18) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_45
            ]),
            _createElementVNode("label", _hoisted_46, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p19",
                value: "1",
                modelValue: _ctx.step1.p19,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.step1.p19) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_47
            ]),
            _createElementVNode("label", _hoisted_48, [
              _createVNode(_component_Field, {
                class: "form-check-input me-3",
                type: "checkbox",
                name: "p20",
                value: "1",
                modelValue: _ctx.step1.p20,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.step1.p20) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_49
            ])
          ]),
          _createVNode(_component_ErrorMessage, {
            name: "riskbenefits",
            class: "fv-plugins-message-container invalid-feedback"
          })
        ]),
        _createElementVNode("div", _hoisted_50, [
          _withDirectives(_createElementVNode("div", null, [
            _hoisted_51,
            _createVNode(_component_editor, {
              licenseKey: "gpl",
              for: "otherInvolvedResearch",
              initialValue: "step1.otherInvolvedResearch",
              modelValue: _ctx.step1.otherInvolvedResearch,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.step1.otherInvolvedResearch) = $event)),
              "api-key": _ctx.currentEditorToken,
              init: {
                height: 150,
                menubar: false,
                plugins: [
                  'advlist autolink lists link image charmap',
                  'searchreplace visualblocks code fullscreen',
                  'print preview anchor insertdatetime media',
                  'paste code help wordcount table',
                ],
                toolbar:
                  'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
              }
            }, null, 8, ["modelValue", "api-key"]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "otherInvolvedResearch",
              class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
              placeholder: "How it will be record?",
              modelValue: _ctx.step1.otherInvolvedResearch,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.step1.otherInvolvedResearch) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "otherInvolvedResearch",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ], 512), [
            [_vShow, _ctx.step1.p19 === '1']
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _hoisted_53,
          _hoisted_54,
          _createVNode(_component_editor, {
            licenseKey: "gpl",
            for: "degreeOfRisks",
            initialValue: "step1.degreeOfRisks",
            modelValue: _ctx.step1.degreeOfRisks,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.step1.degreeOfRisks) = $event)),
            "api-key": _ctx.currentEditorToken,
            init: {
              height: 150,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap',
                'searchreplace visualblocks code fullscreen',
                'print preview anchor insertdatetime media',
                'paste code help wordcount table',
              ],
              toolbar:
                'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
            }
          }, null, 8, ["modelValue", "api-key"]),
          _createVNode(_component_Field, {
            type: "hidden",
            name: "degreeOfRisks",
            class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
            placeholder: "How it will be record?",
            modelValue: _ctx.step1.degreeOfRisks,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.step1.degreeOfRisks) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_ErrorMessage, {
            name: "degreeOfRisks",
            class: "fv-plugins-message-container invalid-feedback"
          })
        ]),
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createVNode(_component_editor, {
            for: "precautions",
            initialValue: "step1.precautions",
            modelValue: _ctx.step1.precautions,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.step1.precautions) = $event)),
            "api-key": _ctx.currentEditorToken,
            licenseKey: "gpl",
            init: {
              height: 150,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap',
                'searchreplace visualblocks code fullscreen',
                'print preview anchor insertdatetime media',
                'paste code help wordcount table',
              ],
              toolbar:
                'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
            }
          }, null, 8, ["modelValue", "api-key"]),
          _createVNode(_component_Field, {
            type: "hidden",
            name: "precautions",
            class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
            placeholder: "How it will be record?",
            modelValue: _ctx.step1.precautions,
            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.step1.precautions) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_ErrorMessage, {
            name: "precautions",
            class: "fv-plugins-message-container invalid-feedback"
          })
        ]),
        _createElementVNode("div", _hoisted_57, [
          _hoisted_58,
          _createVNode(_component_editor, {
            for: "riskInTerms",
            initialValue: "step1.riskInTerms",
            modelValue: _ctx.step1.riskInTerms,
            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.step1.riskInTerms) = $event)),
            "api-key": _ctx.currentEditorToken,
            licenseKey: "gpl",
            init: {
              height: 150,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap',
                'searchreplace visualblocks code fullscreen',
                'print preview anchor insertdatetime media',
                'paste code help wordcount table',
              ],
              toolbar:
                'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
            }
          }, null, 8, ["modelValue", "api-key"]),
          _createVNode(_component_Field, {
            type: "hidden",
            name: "riskInTerms",
            class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
            placeholder: "How it will be record?",
            modelValue: _ctx.step1.riskInTerms,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.step1.riskInTerms) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_ErrorMessage, {
            name: "riskInTerms",
            class: "fv-plugins-message-container invalid-feedback"
          })
        ])
      ])
    ])
  ]))
}